// * 认证枚举配置
/**
 * @description：认证类型枚举
 */

// 认证类型
export enum authTypeEnum {
  PERSON = 1, // 个人认证
  COMPANY = 2 // 企业认证
}
/**
 * @description：认证状态枚举
 */

export enum authStatusEnum {
  ZERO = 0, // 未提交
  AUDIT = 1, // 待审核
  SUCCESS = 2, // 认证成功
  FAIL = 3 // 认证失败
}
